import { render, staticRenderFns } from "./Deportistas.vue?vue&type=template&id=016b8084"
import script from "./Deportistas.vue?vue&type=script&lang=js"
export * from "./Deportistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports